import { Button, Modal, MultiSelect, Select } from "@mantine/core"
import { IconDeviceFloppy } from "@tabler/icons-react"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { CollectionQuery } from "../../../models/collection.model"
import { useCurrentUser } from "../../../shared/hooks/current-user.hook"
import { useLazyGetOwnersOfSaleQuery } from "../../sale/store/sale.query"
import {
  useSendUtilityFeeReminderMutation
} from "../store/lease.query"

type Props = {
  open: any
  opened: boolean
  close: any
}
export default function SendUtilityFeeReminderComponent({
  open,
  opened,
  close,
}: Props) {
  const { t } = useTranslation()
  const [selectedMonths, setSelectedMonths] = useState<string[]>([])
  const [selectedOwner, setSelectedOwner] = useState<string>("")
  const [userInfo, userId, ownerInfo] = useCurrentUser()
  const [ownerCollection, setOwnerCollection] = useState<CollectionQuery>({
    skip: 0,
    top: 100,
  });

  const [getOwners, owners] = useLazyGetOwnersOfSaleQuery();
  const [sendUtilityFeeReminder, sendUtilityFeeReminderResponse] =
    useSendUtilityFeeReminderMutation()

  function closeModal() {
    setSelectedMonths([])
    setSelectedOwner("")
    close()
  }

  useEffect(() => {
    getOwners(ownerCollection);
  }, [ownerCollection])

  function sendUtilityReminder() {
    let data: { ownerId?: string; months?: string[] } = {}
    if (selectedOwner && selectedOwner !== "") {
      data.ownerId = selectedOwner
    }
    if (selectedMonths.length > 0) {
      data.months = selectedMonths
    }
    sendUtilityFeeReminder(data)
  }

  function _parseOwners() {
    const data: { label: string; value: string }[] = []

    owners.data?.data?.map((owners: any) => {
      data.push({ label: owners.name, value: owners.id })
    })

    return data
  }
  function _parseMonths() {
    let months = ["መስከረም",
      "ጥቅምት",
      "ኅዳር", 
      "ታኅሣሥ",
      "ጥር", 
      "የካቲት", 
      "መጋቢት", 
      "ሚያዝያ", 
      "ግንቦት", 
      "ሰኔ", 
      "ሐምሌ", 
      "ነሐሴ", 
      "ጳጉሜ"];
    const data: { label: string; value: string }[] = []

    months.map((months: any) => {
      data.push({ label: months, value: months })
    })

    return data
  }


  return (
    <Modal
      opened={opened}
      onClose={closeModal}
      size={"md"}
      title={"Send Utility Fee Reminder"}
      centered
    >
        <div className="flex gap-8 w-full mt-20 space-x-4 justify-between ">
          <div className="w-full">
            {/* <div className="flex w-full space-x-4  justify-center"> */}
            {userInfo?.role?.key === "super_admin" && (
              <Select
                radius={"xs"}
                classNames={{ label: "dark:text-white" }}
                className="w-full"
                clearable
                // error={errors?.method && `${errors?.method?.message}`}
                label={t("owner", { count: 2 })}
                placeholder={t("owner", { count: 2 })}
                data={_parseOwners()}
                // withAsterisk
                value={selectedOwner}
                onChange={(value) => setSelectedOwner(value as string)}
  
                // {...field}
              />
            )}

            {/* <LoadingInputWrapper isLoading={unitFloors.isFetching}> */}
              <MultiSelect
                radius={"xs"}
                classNames={{ label: "dark:text-white" }}
                className="w-full"
                clearable
                dropdownPosition="bottom"
                // error={errors?.method && `${errors?.method?.message}`}
                label={"Months"}
                placeholder={"Months"}
                data={_parseMonths()}
                // withAsterisk
                value={selectedMonths}
                onChange={(value) => setSelectedMonths(value)}

                // {...field}
              />
            {/* </LoadingInputWrapper> */}

          </div>
        </div>

        <div className="pt-8 flex justify-end">
          <Button
            variant="filled"
            className="bg-primary text-white"
            type="button"
            onClick={() => sendUtilityReminder()}
            classNames={{ label: "flex space-x-1" }}
            size={"xs"}
            loading={sendUtilityFeeReminderResponse.isLoading}
            //  onClick={() => handleAssignDriver()}
          >
            <span>
              <IconDeviceFloppy size={22} strokeWidth={1.5} />
            </span>
            {"Send Reminder"}
          </Button>
        </div>
        
    </Modal>
  )
}
